export default __webpack_public_path__ + "static/media/Deed of Contract - Img - Final (2)_04.444b9b94.jpg";